import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/styles/themes.css";
import "@/styles/login.css";
import { installPressFeedback } from "@/lib/pressFeedback";
import App from "@/App";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

installPressFeedback();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for PWA support
serviceWorkerRegistration.register({
  onSuccess: () => {
    console.log('RENTOS PWA: Ready for offline use');
  },
  onUpdate: (registration) => {
    console.log('RENTOS PWA: New version available');
    if (registration && registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
  }
});
